import { Button } from 'component/Button'
import { SearchInput } from 'component/Input/SearchInput'
import { Scroll } from 'component/Scroll'
import { Divider, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { ColorCheckbox } from 'page/StartScreen/combine/color/ColorCheckbox'
import { getColorTranslation } from 'page/StartScreen/combine/utils'
import { Fragment } from 'react'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { map } from 'util/iterable'

export const ColorStep = observer(() => {
  const { color, colors_filtered } = store.item!.rec

  const onSearch = useLatestCallback((value: string) => {
    color.search = value
  })

  const onRemove = useLatestCallback((value: string) => {
    color.toggle(value)
  })

  const onReset = useLatestCallback(() => {
    color.clear()
  })

  return <Vertical gap={24} tall>
    {!opt.stand && <SearchInput large value={color.search}
      onChange={onSearch} placeholder={i18n('SearchByColor')} />}

    <Vertical oh margin={[0, -12]}>
      <Scroll>
        <Vertical gap={24} pad={[0, 12]}>
          {!!color.selection.size && <Space gap={8} wrap>
            {map(color.selection, color => <Fragment key={color}>
              <Button gap={4} primary onClick={() => onRemove(color)}>
                <Typo size={13} upper>
                  {getColorTranslation(color)}
                </Typo>
                <Icon size={16} name="close" />
              </Button>
            </Fragment>)}
            <Button link onClick={() => onReset()}>
              {i18n('Reset')}
            </Button>
          </Space>}

          <Vertical>
            {!colors_filtered.length && <Space height={200} center>
              <Typo size={13} upper secondary>
                {i18n('NothingFound')}
              </Typo>
            </Space>}
            {colors_filtered.map((color, i) => <Fragment key={color}>
              {i > 0 && <Divider tertiary />}
              <ColorCheckbox color={color} />
            </Fragment>)}
          </Vertical>
        </Vertical>
      </Scroll>
    </Vertical>
  </Vertical>
})
